import { keepPreviousData } from "@tanstack/react-query";
import { RouterOutputs, trpc } from "../trpc";

export type PrivateImplementationMeta =
  RouterOutputs["implementationMeta"]["getPrivateImplementationsMeta"][number];

interface Input {
  selectedApis?: string[];
}

interface Options {
  enabled?: boolean;
}

export function useQueryPrivateImplementationsMeta(
  { selectedApis }: Input,
  { enabled = true }: Options = {},
) {
  const { data, isFetching, isLoading } =
    trpc.implementationMeta.getPrivateImplementationsMeta.useQuery(
      {
        selectedApis: selectedApis || [],
      },
      {
        enabled: !!selectedApis?.length && enabled,
        placeholderData: keepPreviousData,
        trpc: {
          context: {
            // Skip batching to avoid bundling this critical procedure with slower requests
            skipBatching: true,
          },
        },
      },
    );

  return {
    implementationsMeta: (data || []) as PrivateImplementationMeta[],
    isLoading,
    isFetching,
  };
}
